import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

/** Die drei Einrichtungsseiten des Belegwesens (13.4) — Reiter über Routen, keine Unterseiten im Zustand. */
export function SettingsTabs() {
  const { t } = useTranslation()
  const reiter = [
    { to: '/correspondence/settings', label: t('documents.settings.tabs.kinds'), end: true },
    { to: '/correspondence/settings/texts', label: t('documents.settings.tabs.texts'), end: false },
    { to: '/correspondence/settings/layout', label: t('documents.settings.tabs.layout'), end: false },
  ]
  return (
    <div className="flex flex-wrap gap-1 border-b border-border">
      {reiter.map((r) => (
        <NavLink
          key={r.to}
          to={r.to}
          end={r.end}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-4 py-2 text-sm ${isActive ? 'border-primary font-medium text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`
          }
        >
          {r.label}
        </NavLink>
      ))}
    </div>
  )
}
